import { lazy } from "react";
import { FlaskRound } from "lucide-react";

import type { FeatureDescriptor } from "@/features/types";

export const experimentsFeature: FeatureDescriptor = {
  id: "experiments",
  flag: "experiments",
  path: "/experiments",
  group: "admin",
  navKey: "nav.experiments",
  icon: FlaskRound,
  roles: ["admin"],
  element: lazy(() => import("./ExperimentsPage")),
};
